import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { JwtService } from '@app/core/services/jwt.service'
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from "@angular/router"
import { Store } from '@ngrx/store';
import * as CoreActions from '@app/core/store/core.action';
import { selectLocationsState } from '@app/core/store/core.selectors'
import { ILocation } from '@app/models/location.interface';
import { first } from 'rxjs';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, skipWhile, startWith, tap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-forgot-login',
  templateUrl: './forgot-login.component.html',
  styleUrls: ['./forgot-login.component.scss']
})
export class ForgotLoginComponent implements OnInit {
  public processComplete: boolean = false;
  public form: FormGroup;
  public errors = null;
  public successMsg = null;
  public locations$: ILocation[];
  public options$: string[] = [];
  public filteredOptions$: Observable<ILocation[]>;
  public isLoading$: boolean = false;

  constructor(
    public fb: FormBuilder,
    public _jwt: JwtService,
    private store$: Store,
    private _toastr: ToastrService,
    private _router: Router
  ) {
    this.form = this.fb.group({
      usrEmail: new FormControl('', {
        validators: [Validators.required, Validators.email],
        updateOn: 'change' 
      }),
      usrLocation: new FormControl('', {
        validators: [Validators.required],
        updateOn: 'change' 
      })
    });
    this.store$.dispatch(CoreActions.loadLocations());
  }

  ngOnInit(): void {
    this.store$.select(selectLocationsState).pipe(
      skipWhile(res => res == null),
    ).subscribe(locations => {
      this.locations$ = locations;
      this.filteredOptions$ = this.form.get('usrLocation').valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value)),
      );
    });
   }

  onSubmit(){
    this.isLoading$ = true;
    this._jwt.onForgotUser(this.form.value).pipe(
      first(),
    ).subscribe()
    //this._toastr.success(`If a matching email was found, please check your email for further instructions.`);
    this.isLoading$ = false;
    this.processComplete = true;
    // this._router.navigate(['/login']);
  }

  public _filter(value) {
    const filterValue = value.toLowerCase();
    return this.locations$.filter(option => option.locName.toLowerCase().includes(filterValue));
  }

}
